import React, { useEffect, useRef } from 'react';
import { animate } from 'framer-motion';
import { formatCurrency } from '../../utils/format';
interface AnimatedNumberProps {
  value: number;
  format?: (n: number) => string;
  className?: string;
}
export function AnimatedNumber({
  value,
  format = n => formatCurrency(n),
  className = ''
}: AnimatedNumberProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const prev = useRef(value);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const controls = animate(prev.current, value, {
      duration: 0.45,
      ease: [0.23, 1, 0.32, 1],
      onUpdate: v => {
        node.textContent = format(v);
      }
    });
    prev.current = value;
    return () => controls.stop();
  }, [value, format]);
  return <span ref={ref} className={`tabular ${className}`} data-id="element-668" data-mp="8nmkt1uwve9b">
      {format(value)}
    </span>;
}